<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      selectShowPower="/copymerchantInfo/up"
    >
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merNo"
          placeholder="请输入商户号"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input
          v-model="formModel.layerPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号">
        <el-input v-model="formModel.linkPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="注册名称">
        <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 经营名称 -->
      <el-form-item label="经营名称">
        <el-input v-model="formModel.businName" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 新增状态 -->
      <el-form-item label="审核状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 时间 -->
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.activeTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange('activeTime')"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 新增修改时间 -->
      <el-form-item label="修改时间">
        <el-date-picker
          v-model="formModel.activeTimeNew"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 是否删除 -->
      <el-form-item label="是否删除">
        <el-select v-model="formModel.deleteStatus">
          <el-option
            v-for="item in deleteList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 内部商户号 -->
      <el-form-item label="内部商户号">
        <el-input v-model="formModel.id" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 经营类型 -->
        <el-form-item label="经营类型">
        <el-select v-model="formModel.merMode">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
          <!-- 所属代理商 -->
        <el-form-item label="所属代理商">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        fixed="left"
        prop="merNo"
        label="商户号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="merName"
        label="注册名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merMode"
        label="商户经营类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.merMode == 0">企业</span>
          <span v-else-if="scope.row.merMode == 1">个体</span>
          <span v-else-if="scope.row.merMode == 2">小微</span>
        </template>
      </el-table-column>
      <!-- 新增 -->
      <el-table-column
        prop="userId"
        label="所属代理商"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="id"
        label="内部商户号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="businName"
        label="经营名称(店名)"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merAddr"
        label="注册地址"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merAreaName"
        label="注册地区"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccSmallType"
        label="行业类别"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccRemark"
        label="行业类型描述"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="standardFlag"
        label="行业大类"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.standardFlag == 0">标准</span>
          <span v-else-if="scope.row.standardFlag == 1">优惠</span>
          <span v-else-if="scope.row.standardFlag == 2">减免</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="employeeNum"
        label="公司规模"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.employeeNum == 1">0-50人</span>
          <span v-else-if="scope.row.employeeNum == 2">50-100人</span>
          <span v-else-if="scope.row.employeeNum == 3">100以上</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="businForm"
        label="经营形态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.businForm == '01'">连锁店</span>
          <span v-else-if="scope.row.businForm == '02'">普通店</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="审核状态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未提交</span>
          <span v-else-if="scope.row.status == 1">已提交</span>
          <span v-else-if="scope.row.status == 2">审核中</span>
          <span v-else-if="scope.row.status == 3">成功</span>
          <span v-else-if="scope.row.status == 4">失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contractUrl"
        label="上游签约地址"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="auditStatus"
        label="上游状态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == 9">待处理</span>
          <span v-else-if="scope.row.auditStatus == 3">待审核</span>
          <span v-else-if="scope.row.auditStatus == 0">审核通过</span>
          <span v-else-if="scope.row.auditStatus == 'X'">审核失败</span>
          <span v-else-if="scope.row.auditStatus == 1">审核驳回</span>
          <span v-else-if="scope.row.auditStatus == 5">待签约</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operaTrace"
        label="上游操作流水号"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merTrace"
        label="上游唯一标识"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="retMsg"
        label="上游返回信息"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <el-button type="text" @click="toDetail(scope.row)"
              >查看详情
            </el-button>
             <el-button type="text" @click="showDialog(scope.row)" v-if='scope.row.merTrace'
              >子商户号查询
            </el-button>
            <el-button
              type="text"
              @click="joinYisheng(scope.row)"
              v-if="scope.row.status == 1 && !scope.row.merTrace"
              >进件
            </el-button>
            <el-button
              type="text"
              @click="AgencyFun(scope.row)"
              v-if="scope.row.status == 1"
              >签约
            </el-button>
          </div>
        </template>
      </el-table-column>
    </common-table>
    <!-- 新增 -->
    <show-info-dialog
      title="子商户号查询"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
      dialogWidth="1000px"
    >
      <div class="info">
        <div>微信子商户号：{{ showData.wx }}</div>
        <div>支付宝子商户号：{{ showData.zfb }}</div>
      
       
      </div>
   
    </show-info-dialog>
  </div>
</template>

<script>
import ImageViewer from "../../dialog/ImageViewer";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import AyiSheng from "service/AyiSheng";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "bonusplan",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
    ImageViewer,
  },
  data() {
    return {
      dialogAmount: 0,
      show: false,
      statusList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "未提交",
          value: 0,
        },
        {
          name: "已提交",
          value: "1",
        },
        {
          name: "审核中",
          value: "2",
        },
        {
          name: "成功",
          value: "3",
        },
        {
          name: "失败",
          value: "4",
        },
      ],
      deleteList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "否",
          value: "0",
        },
        {
          name: "是",
          value: "1",
        },
      ],
      typeList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "企业",
          value: "0",
        },
        {
          name: "个体户",
          value: "1",
        },
        {
          name: "小微",
          value: "2",
        },
      ],
      formModel: {
        merNo: "", // 商户号
        merName: "", // 商户名称
        linkPhone: "", // 联系人手机号
        layerPhone: "", // 商户手机号
        businName: "", // 经营名称
        status: "", // 审核状态
        activeTime: [], // 时间
        deleteStatus: "", // 删除状态
        merMode: '', // 经营类型
        date: "",
        activeTimeNew: [],
        id: "", // 内部商户号
         userId: ''
      },
      tableData: [],
        answershow: {},
      multipleSelection: [],
      ids: [],
      submitService: AyiSheng.YiShengList,
      submitServiceNew: AyiSheng.seeNewData,
      page: {},
      isPage: false,
      merTrace: '',
      showData: {

      }
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    console.log(this.$route.params, "this.$route.params");
    if (this.$route.params.formModel) {
      this.formModel = JSON.parse(this.$route.params.formModel);
    } else {
      this.formModel = {
        activeTime: [],
        activeTimeNew: [],
      };
    }
    this.load();
  },
  computed: {
    submitDataNew() {
      this.params = {
        merTrace: this.merTrace
      }
      return this.params
    },
    submitData() {
      console.log("wwwwww");
      if (
        this.formModel.activeTime == null ||
        this.formModel.activeTime == ""
      ) {
        this.formModel.activeTime = [];
      }
      if (
        this.formModel.activeTimeNew == null ||
        this.formModel.activeTimeNew == ""
      ) {
        this.formModel.activeTimeNew = [];
      }
      this.params = {
        merNo: this.formModel.merNo,
        merName: this.formModel.merName,
        linkPhone: this.formModel.linkPhone,
        layerPhone: this.formModel.layerPhone,
        businName: this.formModel.businName,
        status: this.formModel.status,
        deleteStatus: this.formModel.deleteStatus,
              userId: this.formModel.userId,
        id: this.formModel.id,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if(this.formModel.merMode) {
        this.params.merMode = this.formModel.merMode
      }
      if (this.formModel.activeTime.length > 0) {
        console.log(this.formModel.activeTime, "this.formModel.activeTime");
        this.params.startDate = this.formModel.activeTime[0];
        this.params.endDate = this.formModel.activeTime[1];
      }
      if (this.formModel.activeTimeNew.length > 0) {
        this.params.updateStartDate = this.formModel.activeTimeNew[0];
        this.params.updateEndDate = this.formModel.activeTimeNew[1];
      }
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {

     async  showDialog(row) {
         console.log(row,'row')
         this.merTrace = row.merTrace
      await this.doLoad(
        this.submitServiceNew,
      this.submitDataNew,
        (res) => {
          this.doCheck(res, (res) => {
            // this.onSuccess(res);
            this.showData = res.contents
           
          });
        },
        "信息获取失败"
      );
      this.$refs.showInfoDialog.open();
    },
    toDetail(row) {
      console.log(row, "row");
      this.$router.push({
        name: "AyiShengChild",
        params: {
          item: JSON.stringify(row),
          formModel: JSON.stringify(this.formModel),
        },
      });
    },
    load() {
      console.log(this.formModel, "formModel");
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          console.log(res, "resresres");
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    // 新增进件
    joinYisheng(item) {
      this.showConfirm("是否进件").then(() => {
        this.joinFun(item.id);
      });
    },
    joinFun(id) {
      this.doLoad(
        AyiSheng.joinYisheng,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    // 新增签约

    AgencyFun(item) {
      this.showConfirm("是否签约").then(() => {
        this.AgencyFunNew(item);
      });
    },
    AgencyFunNew(item) {
      this.doLoad(
        AyiSheng.Agency,
        {
          id: item.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        FinanceService.bonusplanDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.respMsg);
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },

    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res;
        this.tableData = result.contents.rows;
        this.page.currentPage = result.contents.current;
        this.page.total = result.contents.total;
        this.page.pageSize = result.contents.size;
      });
    },
    handleDateChange(field) {
      console.log(`Date changed for ${field}:`, this.formModel[field]);
    },
  },
};
</script>

<style scoped>
.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
.info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.url {
  display: flex;
  flex-wrap: wrap;
  height: 40px;
  align-items: center;
  padding-left: 5px;
}
.info div {
  width: 50%;
  height: 40px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AyiShengFile/AyiSheng.vue